export default __webpack_public_path__ + "media/images/header-logo-8a0f14039f53622acda0169ecda0972e.svg";